export const SERVICES_FR = [
  {
    slug: "house-cleaning",
    name: "Nettoyage résidentiel",
    short: "Nettoyage résidentiel",
    tagline: "Service d'entretien ménager professionnel — hebdomadaire, aux deux semaines ou mensuel — adapté à votre foyer.",
    includes: [
      "Comptoirs, éviers et électroménagers de la cuisine",
      "Salles de bain récurées, désinfectées et polies",
      "Époussetage de toutes les surfaces accessibles",
      "Passage de l'aspirateur sur tapis et escaliers",
      "Lavage de tous les planchers durs",
      "Miroirs et vitres intérieures",
      "Lits faits et draps changés sur demande",
      "Poubelles et recyclage vidés",
    ],
    faqs: [
      { q: "Combien coûte l'entretien ménager à {ville}?", a: "Le prix dépend de la superficie, de l'état et de la fréquence. La plupart des foyers de {ville} reçoivent une soumission à prix fixe en moins d'une heure ouvrable — appelez le {phone}." },
      { q: "Aurai-je la même équipe à chaque visite?", a: "Oui. Les clients réguliers de {ville} sont jumelés à une équipe attitrée, pour que les mêmes professionnels de confiance nettoient votre foyer chaque fois." },
    ],
  },
  {
    slug: "deep-cleaning",
    name: "Grand nettoyage",
    short: "Grand nettoyage",
    tagline: "Un nettoyage intensif de fond en comble qui remet à neuf chaque recoin de votre espace.",
    includes: [
      "Intérieur du four, du réfrigérateur et du micro-ondes",
      "Détartrage complet des salles de bain",
      "Plinthes, cadres de porte et moulures essuyés à la main",
      "Luminaires, évents et ventilateurs dépoussiérés",
      "Derrière et sous les meubles et électroménagers",
      "Vitres intérieures, rails et rebords",
      "Frottage des joints de céramique",
      "Finition complète des planchers, coins inclus",
    ],
    faqs: [
      { q: "Combien de temps prend un grand nettoyage à {ville}?", a: "La plupart des résidences de {ville} prennent de 4 à 8 heures selon la superficie et l'état. Les grandes maisons reçoivent une équipe plus nombreuse pour terminer en une journée." },
      { q: "Quelle est la différence avec un nettoyage régulier?", a: "Le nettoyage régulier entretient; le grand nettoyage restaure. Il cible l'accumulation, les joints, l'intérieur des électroménagers et les zones hors d'une visite standard." },
    ],
  },
  {
    slug: "move-in-out-cleaning",
    name: "Nettoyage de déménagement",
    short: "Nettoyage de déménagement",
    tagline: "Un grand ménage clé en main pour protéger votre dépôt et simplifier la remise des clés.",
    includes: [
      "Intérieur de toutes les armoires et garde-robes",
      "Intérieur du four, du réfrigérateur et du lave-vaisselle",
      "Détartrage et désinfection des salles de bain",
      "Plinthes, portes et cadres de porte",
      "Vitres intérieures, rails et rebords",
      "Nettoyage des marques sur les murs",
      "Aspirateur et lavage de tous les planchers",
      "Photos datées envoyées à la fin des travaux",
    ],
    faqs: [
      { q: "Le nettoyage de sortie à {ville} protège-t-il mon dépôt?", a: "Nos nettoyages de déménagement à {ville} suivent les mêmes listes de contrôle que les gestionnaires immobiliers locaux, avec photos datées — les deux meilleures protections pour votre dépôt." },
      { q: "Faut-il que le logement soit vide?", a: "Idéalement oui. Le nettoyage est plus complet une fois les meubles sortis, mais nous pouvons contourner les items restants au besoin." },
    ],
  },
  {
    slug: "commercial-cleaning",
    name: "Nettoyage commercial",
    short: "Nettoyage commercial",
    tagline: "Programmes d'entretien commercial et de bureaux, planifiés selon vos heures d'affaires.",
    includes: [
      "Postes de travail, bureaux et surfaces partagées",
      "Toilettes nettoyées, désinfectées et réapprovisionnées",
      "Cuisinettes et salles de pause détaillées",
      "Déchets, recyclage et compost gérés",
      "Aspirateur et entretien des planchers durs",
      "Vitres d'entrée et portes détaillées",
      "Salles de conférence et réception remises en ordre",
      "Désinfection des points de contact fréquents",
    ],
    faqs: [
      { q: "Nettoyez-vous les bureaux après les heures d'ouverture à {ville}?", a: "Oui — la plupart de nos clients commerciaux de {ville} sont desservis en soirée ou tôt le matin, pour une équipe qui arrive chaque jour dans un espace frais." },
      { q: "Faut-il un contrat à long terme?", a: "Non. La plupart de nos clients de {ville} fonctionnent au mois. Nous gardons les contrats simples et laissons la qualité vous convaincre." },
    ],
  },
  {
    slug: "carpet-cleaning",
    name: "Nettoyage de tapis",
    short: "Nettoyage de tapis",
    tagline: "Extraction à l'eau chaude qui élimine taches, allergènes et odeurs en profondeur.",
    includes: [
      "Inspection et essai des fibres",
      "Prétraitement des taches et zones passantes",
      "Extraction à l'eau chaude (vapeur)",
      "Traitements des odeurs et taches d'animaux",
      "Nettoyage en profondeur des meubles rembourrés",
      "Nettoyage de carpettes",
      "Séchage rapide par ventilateurs",
      "Brossage du poil et inspection finale",
    ],
    faqs: [
      { q: "Combien de temps sèchent les tapis à {ville}?", a: "Avec notre procédé de séchage rapide, la plupart des tapis sèchent en 4 à 8 heures à {ville}." },
      { q: "Pouvez-vous éliminer les odeurs d'animaux?", a: "Oui — nous utilisons des traitements enzymatiques qui neutralisent l'urine à la source, suivis d'une extraction en profondeur." },
    ],
  },
  {
    slug: "window-cleaning",
    name: "Lavage de vitres",
    short: "Lavage de vitres",
    tagline: "Lavage de vitres intérieur et extérieur sans traces, pour résidences et commerces.",
    includes: [
      "Lavage des vitres extérieures",
      "Vitres et miroirs intérieurs",
      "Cadres, rails et rebords nettoyés",
      "Moustiquaires retirées et lavées",
      "Puits de lumière et rampes de verre",
      "Programmes pour vitrines de commerces",
      "Enlèvement des taches d'eau dure",
      "Rinçage à l'eau pure sans résidu",
    ],
    faqs: [
      { q: "À quelle fréquence laver les vitres à {ville}?", a: "La plupart des résidences de {ville} réservent deux fois par année — printemps et automne. Les vitrines commerciales sont généralement mensuelles." },
      { q: "Les rails et cadres sont-ils inclus?", a: "Oui. Contrairement aux services rapides, chaque visite inclut rails, rebords et cadres essuyés à la main." },
    ],
  },
  {
    slug: "post-construction-cleaning",
    name: "Nettoyage après construction",
    short: "Nettoyage après construction",
    tagline: "Nettoyage brut, final et « coup d'éclat » qui mène votre chantier à la remise des clés.",
    includes: [
      "Extraction de la poussière fine sur toutes les surfaces",
      "Intérieur des armoires, tiroirs et garde-robes",
      "Vitres, cadres et rails détaillés",
      "Enlèvement d'autocollants et d'éclaboussures de peinture",
      "Frottage et polissage des planchers",
      "Évents et ouvertures de conduits aspirés",
      "Enlèvement des débris et matériaux",
      "Nettoyage « coup d'éclat » avant l'occupation",
    ],
    faqs: [
      { q: "Travaillez-vous avec les entrepreneurs de {ville}?", a: "Oui — la majorité de nos contrats après construction à {ville} viennent d'entrepreneurs et de promoteurs, selon les phases brut, final et coup d'éclat." },
      { q: "Gérez-vous la poussière fine de gypse?", a: "C'est le cœur du métier. Nous utilisons des aspirateurs à filtre HEPA et plusieurs passages humides pour réellement l'éliminer." },
    ],
  },
  {
    slug: "airbnb-cleaning",
    name: "Nettoyage Airbnb",
    short: "Nettoyage Airbnb",
    tagline: "Nettoyage de rotation cinq étoiles : rotations le jour même, literie et réapprovisionnement.",
    includes: [
      "Nettoyage complet entre chaque invité",
      "Changement de la literie et des serviettes",
      "Cuisine et salle de bain aux normes hôtelières",
      "Réapprovisionnement des essentiels",
      "Mise en scène selon vos photos d'annonce",
      "Signalement des bris et dégâts",
      "Photos datées après chaque rotation",
      "Horaire synchronisé à votre calendrier",
    ],
    faqs: [
      { q: "Gérez-vous les rotations le jour même à {ville}?", a: "Oui — c'est notre spécialité. Nous planifions les équipes selon vos heures d'arrivée et de départ à {ville}, avec photos avant chaque arrivée." },
      { q: "Fournissez-vous la literie?", a: "Nous offrons des programmes complets de literie et serviettes, ou nous lavons et replaçons les vôtres — selon votre annonce." },
    ],
  },
  {
    slug: "janitorial-services",
    name: "Services de conciergerie",
    short: "Services de conciergerie",
    tagline: "Programmes quotidiens de conciergerie, préposés de jour et entretien complet d'immeubles.",
    includes: [
      "Programmes de nettoyage de jour et de soir",
      "Désinfection et réapprovisionnement des toilettes",
      "Gestion des fournitures et consommables",
      "Déchets, recyclage et compost",
      "Entretien du hall d'entrée et des aires communes",
      "Préposés de jour disponibles",
      "Frottage mécanique des planchers durs",
      "Désinfection des points de contact",
    ],
    faqs: [
      { q: "Quels immeubles desservez-vous à {ville}?", a: "Bureaux, écoles, cliniques, commerces et immeubles multilocataires partout à {ville} et au Québec — d'un seul étage à l'immeuble complet." },
      { q: "Comment la qualité est-elle contrôlée?", a: "Chaque compte de conciergerie à {ville} reçoit un superviseur attitré et des audits mensuels notés, partagés directement avec vous." },
    ],
  },
  {
    slug: "eco-friendly-cleaning",
    name: "Nettoyage écologique",
    short: "Nettoyage écologique",
    tagline: "Produits verts certifiés et méthodes sans produits toxiques — résultat impeccable, zéro compromis.",
    includes: [
      "Produits de nettoyage verts certifiés",
      "Solutions non toxiques et biodégradables",
      "Aspirateurs à filtration HEPA",
      "Systèmes de microfibres peu de déchets",
      "Options sans fragrance",
      "Protocoles adaptés aux allergies",
      "Sécuritaire pour enfants et animaux",
      "Méthodes respectueuses de la qualité de l'air",
    ],
    faqs: [
      { q: "Les produits verts nettoient-ils vraiment aussi bien?", a: "Oui — les produits verts certifiés modernes égalent la performance conventionnelle, et nos méthodes microfibre + HEPA améliorent encore le résultat." },
      { q: "Est-ce sécuritaire pour les enfants et animaux à {ville}?", a: "C'est exactement le but. Chaque produit utilisé est non toxique et biodégradable — sécuritaire pour toute la famille à {ville}." },
    ],
  },
  {
    slug: "maid-service",
    name: "Service d'aide-ménagère",
    short: "Aide-ménagère",
    tagline: "Une professionnelle de confiance, la même personne à chaque visite, selon votre horaire.",
    includes: [
      "Nettoyage résidentiel récurrent planifié",
      "La même professionnelle à chaque visite",
      "Cuisine et salle de bain complètes",
      "Époussetage, aspirateur et lavage des planchers",
      "Service de lessive et changement des draps",
      "Lits faits et chambres remises en ordre",
      "Vaisselle et remise en ordre de la cuisine",
      "Liste de tâches personnalisée à chaque visite",
    ],
    faqs: [
      { q: "Aurai-je la même personne à chaque visite à {ville}?", a: "Oui — le service repose sur la constance. Les clients de {ville} gardent la même professionnelle, avec une remplaçante formée en cas d'absence." },
      { q: "Puis-je personnaliser la liste de tâches?", a: "Entièrement. Lessive, draps, vaisselle, rangement — votre liste est établie avec votre aide-ménagère et ajustée en tout temps au {phone}." },
    ],
  },
  {
    slug: "pressure-washing",
    name: "Lavage sous pression",
    short: "Lavage sous pression",
    tagline: "Lavage extérieur haute puissance pour revêtements, entrées, terrasses et façades.",
    includes: [
      "Lavage doux du revêtement extérieur",
      "Nettoyage d'entrées et de trottoirs",
      "Restauration de terrasses et clôtures",
      "Lavage de patios et pavé uni",
      "Façades et vitrines commerciales",
      "Traitement des algues, moisissures et mousses",
      "Traitement des taches de sel de déglaçage",
      "Lavage avant peinture ou mise en vente",
    ],
    faqs: [
      { q: "Quelle est la saison du lavage sous pression à {ville}?", a: "Généralement du printemps à l'automne à {ville}. Réservez tôt — mai et juin partent vite après l'hiver québécois." },
      { q: "Le lavage sous pression endommagera-t-il mon revêtement?", a: "Pas avec nous. Nous utilisons le lavage doux pour le vinyle et le bois, et réservons la haute pression au béton et à la pierre." },
    ],
  },
];
